// @flow
import React from 'react';
import { components } from '@peachjar/components';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { styles } from './SendStaffIntro.css.js';
import config from '../../../../config';

const {
  Buttons: { ButtonPrimaryLarge, ButtonSecondarySmall },
} = components;

const ORG_SETUP_ROUTE = '/onboarding/setup/organization';
const TRAINING_LINK = `${config.REACT_APP_SCHOOL_ONBOARDING_URL}/training`;

const onContinueClick = history => () => {
  history.push(ORG_SETUP_ROUTE);
};

type ReduxDispatchProps = {|
  +handleStaffEmailSubmit: () => void,
|};

type ReduxStateProps = {|
  +staffSendDisable: boolean,
  +staffEmailSent: boolean,
|};

type Props = {|
  ...ReduxDispatchProps,
  ...ReduxStateProps,
  history: any,
  haveStaffBeenEmailed: boolean,
  districtName: string,
  registrant: any,
  contactPhoneNumber: string,
|};

const createStaffEmailContent = (
  districtName,
  { firstName, lastName, email },
  contactPhoneNumber
) => ({
  subject: `${districtName} is launching Peachjar for Digital Flyers!`,
  block1: 'Hello Staff,',
  block2: `We're excited to announce that we are going to begin using Peachjar to send digital flyers home to families via email. Sending flyers digitally will not only save our district time and money, but also ensures our families have access to all the valuable resources and programs our schools and community has to offer. School and after school programs are vital to student achievement, and Peachjar will connect our families to these types of opportunities to help our students succeed.`,
  block3: `Upon launch, all parents with an email address on file will automatically begin receiving these flyers via email. Flyers can also be accessed by clicking the Peachjar button located on each school's website homepage.`,
  block4: `You have been given Peachjar privileges by ${districtName}.`,
  block5: 'Click the "Start Training" button to set up your password and view the training. Please view all training to get up and running!',
  buttonText: 'Start Training',
  bestRegards: 'Best Regards,',
  registrantName: `${firstName} ${lastName}`, // TODO: Get this value from Redux
  registrantPhone: contactPhoneNumber, // TODO: Get this value from Redux
  registrantEmail: email, // TODO: Get this value from Redux
});

const SetStaffIntro = ({
  staffSendDisable,
  staffEmailSent,
  handleStaffEmailSubmit,
  haveStaffBeenEmailed,
  history,
  districtName,
  registrant,
  contactPhoneNumber,
}: Props) => {
  const staffEmailContent = createStaffEmailContent(
    districtName,
    registrant,
    contactPhoneNumber
  );

  return (
    <div>
      <div className={styles.wrapper}>
        <h3 className={styles.pageHeader}>
          Send an Introduction Email to Your Staff
        </h3>
        <p className={styles.pageText}>
          Use the following email to introduce Peachjar to your staff. All you
          have to do is click send!
        </p>
        <p className={styles.label}>Email Subject</p>
        <div className={styles.emailSubject}>
          <p className={styles.emailSubjectText}>{staffEmailContent.subject}</p>
        </div>
        <p className={styles.label}>Message</p>
        <div className={styles.emailMessage}>
          <p className={styles.emailMessageText}>{staffEmailContent.block1}</p>
          <p className={styles.emailMessageText}>{staffEmailContent.block2}</p>
          <p className={styles.emailMessageText}>{staffEmailContent.block3}</p>
          <p className={styles.emailMessageText}>{staffEmailContent.block4}</p>
          <p className={styles.emailMessageText}>{staffEmailContent.block5}</p>
          <ButtonPrimaryLarge disabled style={{ marginBottom: '1rem' }}>
            {staffEmailContent.buttonText}
          </ButtonPrimaryLarge>
          <p className={styles.emailBestRegards}>
            {staffEmailContent.bestRegards}
          </p>
          <span>{staffEmailContent.registrantName}</span>
          <br />
          <span className={styles.emailSmallSignatureText}>
            {staffEmailContent.registrantPhone}
          </span>
          <br />
          <span className={styles.emailSmallSignatureText}>
            {staffEmailContent.registrantEmail}
          </span>
        </div>
        <div className={styles.sendButtonWrapper}>
          <ButtonPrimaryLarge
            disabled={
              haveStaffBeenEmailed || staffEmailSent || staffSendDisable
            }
            onClick={handleStaffEmailSubmit}
            data-testid="click-StaffEmailSubmit"
          >
            Send
          </ButtonPrimaryLarge>
        </div>
        {(haveStaffBeenEmailed || staffEmailSent) && (
          <div>
            <h3 className={styles.pageHeader}>Training</h3>
            <p className={styles.pageText}>
              Use the following link if you need to send out training again.
            </p>
            <div className={styles.trainingLinkWrapper}>
              <div className={styles.trainingLink}>{TRAINING_LINK}</div>
              <div>
                <CopyToClipboard text={TRAINING_LINK}>
                  <ButtonSecondarySmall>Copy Link</ButtonSecondarySmall>
                </CopyToClipboard>
              </div>
            </div>
          </div>
        )}
        <div className={styles.continueButtonWrapper}>
          <ButtonPrimaryLarge onClick={onContinueClick(history)}>
            Continue to Organization Setup
          </ButtonPrimaryLarge>
        </div>
      </div>
    </div>
  );
};

export default SetStaffIntro;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff/containers/SendStaffIntroTab.jsx